import React, { useEffect, useState } from 'react'
import { FiChevronRight, FiInbox } from 'react-icons/fi'
import { FaAndroid } from 'react-icons/fa'

const Page = () => {

    const [lists, setLists] = useState([])
    const [loading, setLoading] = useState(true)
    const [fetched, setFetched] = useState(false)

    const getLists = () => {
        setLoading(true)
        setFetched(false)

        const header = {
            "content-type": "application/json",
            accept: "application/json"
        }

        fetch('https://a1.adsai.tech/api/v1/retail-apk/', {
            method: "GET",
            headers: header
        }).then(response => {
            return response.json().then(data => {
                const visibleLists = Array.isArray(data)
                    ? data.filter((item) => item.is_visible === true)
                    : []
                setLists(visibleLists)
                setFetched(true)
            })
        })
        .catch(error => {
            setLists([])
            setFetched(false)
        })
        .finally(() => {
            setLoading(false)
        })
    }

    useEffect(() => {
        getLists()
    }, [])

    const download = (url) => {
        const a = document.createElement('a')
        a.href = url
        a.download = url.split('/').pop()
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
    }

    const getMeta = (item) => {
        const parts = []
        if (item.version !== undefined && item.version !== null && item.version !== '') {
            parts.push(`Version ${item.version}`)
        }
        parts.push('Android APK')
        return parts.join(' · ')
    }

    return (
        <div className="apk-page">
            <div className="apk-page__glow" aria-hidden="true"></div>

            <header className="apk-header">
                <img
                    src={require('../../assets/img/logo.png').default}
                    className="apk-logo"
                    alt="Ads AI"
                />
                <p className="apk-kicker mt-5">Signage Downloads</p>
                <p className="apk-subtitle">Select an app below to start the download.</p>
            </header>

            <main className="apk-list">
                {loading ? (
                    <div className="apk-loader" role="status" aria-live="polite">
                        <div className="apk-spinner"></div>
                        <p>Loading available apps...</p>
                    </div>
                ) : lists && lists.length > 0 ? (
                    lists.map((item, index) => (
                        <button
                            key={item.id}
                            type="button"
                            className="apk-card"
                            autoFocus={index === 0}
                            onClick={() => download(item.file)}
                        >
                            <span className="apk-card__icon">
                                <FaAndroid />
                            </span>
                            <span className="apk-card__body">
                                <span className="apk-card__title">{item.title}</span>
                                <span className="apk-card__meta">{getMeta(item)}</span>
                            </span>
                            <span className="apk-card__chevron" aria-hidden="true">
                                <FiChevronRight />
                            </span>
                        </button>
                    ))
                ) : fetched ? (
                    <div className="apk-empty">
                        <span className="apk-empty__icon"><FiInbox /></span>
                        <p>No Records Found!</p>
                    </div>
                ) : null}
            </main>

            <footer className="apk-footer">
                <p>Copyright @ {new Date().getFullYear()} with signage.adsai.tech. All rights reserved.</p>
            </footer>
        </div>
    )
}

export default Page
